import { http } from '@/http/axios.js'

// 列表
export function getListAPI(params) {
  return http({
    url: `/api/manage/staff/biaoxun/list`,
    method: 'POST',
    params
  })
}

export function spiderOnlinePageAPI(data) {
  return http({
    url: `/api/manage/staff/spider/online/spiderDetail`,
    method: 'POST',
    data
  })
}

export function delAPI(id) {
  return http({
    url: `/api/manage/staff/biaoxun/del?id=${id}`,
    method: 'post',
    data: {}
  })
}
export function addAPI(data) {
  return http({
    url: `/api/manage/staff/biaoxun/add`,
    method: 'post',
    data
  })
}

export function editAPI(data) {
  return http({
    url: `/api/manage/staff/biaoxun/edit`,
    method: 'post',
    data
  })
}

export function getDetailAPI(id) {
  return http({
    url: `/api/manage/staff/biaoxun/detail`,
    method: 'post',
    params: { id }
  })
}


export function getTreeAPI(params) {
  return http({
    url: `/api/manage/staff/bidGuide/tree`,
    method: 'POST',
    params
  })
}

